'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'calendar-exclamation';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f334';
var svgPathData = 'M256 400C256 417.7 241.7 432 224 432C206.3 432 192 417.7 192 400C192 382.3 206.3 368 224 368C241.7 368 256 382.3 256 400zM248 312C248 325.3 237.3 336 224 336C210.7 336 200 325.3 200 312V248C200 234.7 210.7 224 224 224C237.3 224 248 234.7 248 248V312zM152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;